/**
 * タブの状態を更新する
 * @param {NodeListOf<Element>} tabs - すべてのタブ要素
 * @param {Element} activeTab - アクティブにするタブ要素
 */
function updateTabStates(tabs, activeTab) {
  tabs.forEach(tab => {
    const isActive = tab === activeTab;
    const parentLi = tab.closest('li');
    if (parentLi) {
      parentLi.classList.toggle('border-solid', isActive);
    }
    tab.classList.toggle('u-text-main', isActive);
    tab.classList.toggle('font-semibold', isActive);
    tab.classList.toggle('u-text-disabled', !isActive);
  });
}

/**
 * コンテンツの表示/非表示を切り替える
 * @param {NodeListOf<Element>} tabContents - すべてのコンテンツ要素
 * @param {string} activeContentId - 表示するコンテンツのID
 */
function updateContentVisibility(tabContents, activeContentId) {
  tabContents.forEach(content => {
    content.classList.toggle('hidden', content.dataset.content !== activeContentId);
  });
}

/**
 * 汎用タブ切り替えモジュール
 * @param {string} tabSelector - タブ要素のセレクタ (例: '.js-privacy-policy-tab')
 * @param {string} contentSelector - コンテンツ要素のセレクタ (例: '.js-privacy-policy-content')
 */
export function initTabSwitcher(tabSelector, contentSelector) {
  const tabs = document.querySelectorAll(tabSelector);
  const tabContents = document.querySelectorAll(contentSelector);

  if (tabs.length > 0 && tabContents.length > 0) {
    // 初期状態を設定（最初のタブをアクティブにする）
    const firstTab = tabs[0];
    const firstContentId = firstTab.dataset.target;
    updateTabStates(tabs, firstTab);
    updateContentVisibility(tabContents, firstContentId);

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = tab.dataset.target;
        updateTabStates(tabs, tab);
        updateContentVisibility(tabContents, targetId);
      });
    });
  }
}
